import { createSelector } from '@reduxjs/toolkit';
import { isEmpty, size } from 'lodash';

import { SIMILAR_PACKAGES_STATE } from '../constants/similar-packages';
import { getPackageEndDate } from '../../../../utils/dateUtils';
import {
  getStartDate,
  getEndDate,
  getNightsCount,
  getAdultsCount,
  makeGetKids,
} from './package';

const getSimilarPackages = (state) => state.get('similarPackages');
const getSimilarPackagesAdjust = (state) =>
  getSimilarPackages(state).get('adjust');
const _getSimilarPackagesOffers = (state) =>
  getSimilarPackages(state).get('tours');
const _getSimilarPackagesHotelOffersCount = (state) =>
  getSimilarPackages(state).get('hotelOffersCount');

export const getSimilarPackagesFailed = (state) =>
  getSimilarPackages(state).get('failed');
export const getSimilarPackagesState = (state) =>
  getSimilarPackages(state).get('state');

export const getSimilarPackageIsPopupOpened = (state) =>
  getSimilarPackages(state).get('isPopupOpened');

export const getSimilarPackagesOffers = createSelector(
  _getSimilarPackagesOffers,
  (offers) => offers && offers.toJS(),
);

export const getSimilarPackagesFetching = createSelector(
  getSimilarPackagesState,
  (state) => state === SIMILAR_PACKAGES_STATE.PERFORMING,
);

export const getSimilarPackagesHotelOffersCount = createSelector(
  [_getSimilarPackagesHotelOffersCount, getSimilarPackagesOffers],
  (hotelOffersCount, similarPackagesOffers) =>
    similarPackagesOffers && hotelOffersCount - size(similarPackagesOffers),
);

export const getIsExcludeOperator = (state) =>
  getSimilarPackages(state).get('excludeCurrentOperator');

// SEARCHER PARAMS
const _getSearcherStartDate = (state) =>
  getSimilarPackagesAdjust(state).get('date');
const _getSearcherNights = (state) =>
  getSimilarPackagesAdjust(state).get('nights');
const _getSearcherKids = (state) =>
  getSimilarPackagesAdjust(state).get('kidsAges');
const getSearcherAdults = (state) =>
  getSimilarPackagesAdjust(state).get('adults');

const getSearcherKids = createSelector(
  _getSearcherKids,
  (kids) => kids && kids.toJS(),
);

export const getSearcherNights = createSelector(
  [_getSearcherNights, getNightsCount],
  (searcherNights, originalNights) => searcherNights || originalNights,
);

export const getSearcherStartDate = createSelector(
  [_getSearcherStartDate, getStartDate],
  (searcherStartDate, originalStartDate) =>
    searcherStartDate || originalStartDate,
);

export const getSimilarPackagesAdjustParams = createSelector(
  getSimilarPackagesAdjust,
  (adjust) => adjust && adjust.toJS(),
);

/**
 * Если пользователь изменил дату вылета, то складываем дату вылета + количество ночей
 * По-умолчанию показываем package.end_date
 */
export const getSearcherEndDate = createSelector(
  [
    getSimilarPackagesAdjustParams,
    getSearcherStartDate,
    getSearcherNights,
    getEndDate,
  ],
  (adjustParams, searcherStartDate, searcherNights, endDate) =>
    isEmpty(adjustParams)
      ? endDate
      : getPackageEndDate(searcherStartDate, searcherNights),
);

export const getSearcherAdultsCount = createSelector(
  [getSearcherAdults, getAdultsCount],
  (searcherAdults, originalAdults) => searcherAdults || originalAdults,
);

export const getSearcherKidsAges = createSelector(
  [getSearcherKids, makeGetKids],
  (searcherKids, originalKids) => searcherKids || originalKids,
);

export const getSimilarPackagesHasAdjustParams = createSelector(
  getSimilarPackagesAdjustParams,
  (adjust) => !isEmpty(adjust),
);

export const getSimilarPackagesHasChangedTourists = createSelector(
  [getSearcherAdults, getSearcherKids],
  (adults, kids) => Boolean(adults || kids),
);

// CREATE
export const getSimilarPackagesRequestId = (state) =>
  getSimilarPackages(state).get('newRequestId');
